/**
 * File used to define the routes constants for the application.
 * * This file contains the route constants used in the application.
 * * It is used to avoid hardcoding the routes in the application.
 */

const CREDIT_MODULE_ROUTES_CONSTANTS = {
  DISPERSION_METHOD: 'dispersion-method',
  SIGN_APPLICATION: '/sign-application',
  REFERENCES: '/references',
  PRODUCT_VALIDATIONS: '/productValidations',
  EXTEND_TERM: 'extend-term/',
  RENEGOTIATE_LOAN: 'renegotiate-loan/',
  VALUE_TO_PAY: 'value-to-pay',
  RAPIFLEX_NOW: 'rapiflex-now/',
  GRAY_ZONE: 'LoanApplicationGrayZone',
  REJECTED: 'LoanApplicationRejected',
  DECISION_MODEL: '/decision-model',
  DOCUMENT_ISSUE: '/confirmDateOfIssue',
  REFINANCE_LOAN: '/refinance-loan',
  APPLICATION_REJECTION: 'application-rejection',
};

const HOME_MODULE_ROUTES_CONSTANTS = {
  HOME: '/home',
  NEW_LOAN: '/newLoan',
  REFERRALS: '/referrals',
};

export const ROUTES_CONSTANTS = {
  ...CREDIT_MODULE_ROUTES_CONSTANTS,
  ...HOME_MODULE_ROUTES_CONSTANTS,
};
